import React, { useEffect, useState } from 'react';
import { css } from '@emotion/core';
import styles from '../../styles';

export default function SidebarToggleIcon() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const storedState = localStorage.getItem('sidebar-collapsed');

    if (storedState === 'collapsed') {
      setCollapsed(true);
      const el = document.querySelector('#main-content');
      if (el) {
        el.setAttribute('data-toggle', 'collapsed');
      }
    }
  }, []);

  const handleClick = () => {
    if (typeof window === 'undefined') return;
    const el = document.querySelector('#main-content');
    if (!el) return;
    const newState = collapsed ? 'expanded' : 'collapsed';
    el.setAttribute('data-toggle', newState);
    setCollapsed(!collapsed);
    localStorage.setItem('sidebar-collapsed', newState);
  };

  return (
    <svg
      css={style}
      onClick={handleClick}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      data-toggle={collapsed ? 'collapsed' : 'expanded'}
      strokeLinejoin='round'>
      {collapsed ? <path d='M9 6l6 6-6 6' /> : <path d='M15 6l-6 6 6 6' />}
    </svg>
  );
}

const style = css`
  position: fixed;
  top: 9rem;
  left: 27%;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0.5rem;
  background: white;
  border: 1px solid ${styles.border.color.grey};
  border-radius: 0.25rem;
  box-shadow: ${styles.shadow.light};
  cursor: pointer;
  z-index: 1000;

  svg {
    width: 100%;
    height: 100%;
  }

  &[data-toggle='collapsed'] {
    left: 2rem;
  }

  @media (max-width: 1200px) {
    left: 30%;
    &[data-toggle='collapsed'] {
      left: 1.8rem;
    }
  }

  @media (min-width: 1201px) and (max-width: 1440px) {
    left: 23%;
  }

  @media (min-width: 1441px) and (max-width: 1900px) {
    left: 26%;
  }

  @media (min-width: 1901px) {
    &[data-toggle='collapsed'] {
      left: 1.6rem;
    }
  }

  @media (max-width: ${styles.breakpoint.md}) {
    display: none;
  }
`;
